














































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class DialogDataTable extends Vue {
  @Prop({required: true}) title!: string;
  @Prop({default: () => []}) items!: any[];
  @Prop({default: () => []}) headers!: [];
  @Prop({default: 'isSelectable'}) selectableKey!: string;

  search = '';
  dialog = false;

  get itemList() {
    return this.items || [];
  }

  clickRow(val: any) {
    this.$emit('clickRow', val);
    this.dialog = false;
  }
}
